import React, { useEffect, useState, forwardRef, useRef, useImperativeHandle } from "react";
import AdyenCheckout from '@adyen/adyen-web';
import '@adyen/adyen-web/dist/adyen.css';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { useHistory } from 'react-router';
import { getStorePaymentDetails, passPaymentMethodToDropin } from "../../../../RestaurantWidget/utilities/api/paymentService";
import { LOCAL_STORAGE_ITEMS_NAMES } from "../../../../../../utilities/helper";
import globalValues from "../../../../../../utilities/apiRequests/globalValues";


const EcommercePayment = forwardRef((props, ref) => {
    const cardRef = useRef(null);
    const latestCardState = useRef(null);
    let history = useHistory();
    const companyDetails = useSelector((state) => state.companyData.companyDetails);
    const company = useSelector((state) => state.companyData.company);

    const [paymentMethods, setPaymentMethods] = useState(null)

    useEffect(() => {
        const orderID = sessionStorage.getItem('ordernumber')

        if (company && orderID !== "") {
            let ref = uuidv4();
            const requestBody = {
                clientAPIRequestRef: ref,
                cloudLocationID: company?.LocationID,
                store: `Ecommerce_${company?.LocationID}`
            }
            getStorePaymentDetails(requestBody, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
                if (response) {
                    setPaymentMethods(response)
                }
            })
        }

    }, [])

    const makeInstantPayment = async (data) => {
        return new Promise((resolve) => {
            const uniqueID = uuidv4()
            const orderID = sessionStorage.getItem('ordernumber')
            const { paymentMethod } = data
            const paymentRequestBody = {
                amount: {
                    currency: "GBP",
                    value: props.total
                },
                cloudLocationID: company?.LocationID,
                reference: `Online-${company?.LocationID}-Ecom-${uniqueID}`,
                siteTransactionRef: orderID,
                returnUrl: window.location.href,
                store: `Ecommerce_${company?.LocationID}`,
                countryCode: "GB",
                shopperEmail: props.customerDetails.Email.trim(),
                ShopperName: `${props.customerDetails.Name.FirstName} ${props.customerDetails.Name.LastName}`,
                telephoneNumber: `${props.customerDetails.Contact.PinCode}${props.customerDetails.Contact.Number}`,
                paymentMethod,
                isTokenized: false,
                APISource: "Web",
                shopperReference: localStorage.getItem(LOCAL_STORAGE_ITEMS_NAMES.ECOM_RESTAURANT_USER_ID),
                additionalData: {
                    "allow3DS2": "true"
                },
            }
            console.log(paymentRequestBody, "paymentRequestBody")
            passPaymentMethodToDropin(paymentRequestBody, companyDetails.PaymentIntegration.IntegrationData.Client_Key).then((response) => {
                resolve(response)
            }).catch(error => {
                history.push(`/order-failed`)
            });
        })

    }

    const handleTransaction = (stage) => {
        if (stage === "Authorised" || stage === "Received" || stage === "AuthenticationNotRequired") {
            props.placeCartOrder()
        }
        else if (stage === "ChallengeShopper" || stage === "PresentToShopper" || stage === "AuthenticationNotRequired" || stage === "RedirectShopper" || stage === "IdentifyShopper") {


        } else {
            history.push(`/order-failed`)
        }
    }

    useEffect(() => {
        const initCheckout = async () => {

            const configuration = {
                paymentMethodsResponse: paymentMethods, // The `/paymentMethods` response from the server.
                clientKey: globalValues.payment.REACT_APP_PAYMENT_CLIENT_KEY, // Web Drop-in versions before 3.10.1 use originKey instead of clientKey.
                locale: "en-US",
                environment: globalValues.payment.REACT_APP_PAYMENT_CLIENT_ENVIRONMENT,
                analytics: {
                    enabled: true // 
                },
                onSubmit: (state, dropin) => {
                    if (state.data.storePaymentMethod === false) {
                        props.setIsOrderLoading(true)
                        makeInstantPayment(state.data)
                            .then((response) => {
                                if (response.action) {
                                    dropin.handleAction(response.action);
                                } else {
                                    handleTransaction(response.resultCode)
                                }
                            })

                    }
                },
                onChange: (state) => {
                    latestCardState.current = state;
                },
                paymentMethodsConfiguration: {
                    card: {
                        hasHolderName: true,
                        holderNameRequired: true,
                        enableStoreDetails: true,
                        hideCVC: false,
                        showPayButton: false
                    }
                },
            };

            const checkout = await AdyenCheckout(configuration);
            const card = checkout
                .create('card', {
                    openFirstPaymentMethod: false,
                })
            card.mount('#card-container');
            cardRef.current = card;

        }
        if (paymentMethods)
            initCheckout()
    }, [paymentMethods])
    useImperativeHandle(ref, () => ({
        submit: () => {
            const card = cardRef.current;
            if (card && card.isValid) {
                card.submit();
            } else {
                const state = latestCardState.current || {};
                const pm = state.data?.paymentMethod || {};
                const emptyFields = {
                    cardNumber: !pm.encryptedCardNumber,
                    expiryMonth: !pm.encryptedExpiryMonth,
                    expiryYear: !pm.encryptedExpiryYear,
                    cvc: !pm.encryptedSecurityCode,
                    holderName: !pm.holderName || pm.holderName.trim() === ''
                };
                props.setIsOrderLoading(false)
                if (!emptyFields.cardNumber || !emptyFields.expiryMonth || !emptyFields.expiryYear || !emptyFields.cvc || !emptyFields.holderName) {
                    props.setShowPaymentErrorModal(true)
                } else {
                    props.setShowPaymentError(true)
                }
            }
        }
    }));
    return <div id="card-container"></div>
})
export default EcommercePayment